export * from './a2t-form.service';
export * from './a2t-form-field/a2t-form-field.component';
export * from './a2t-form.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/angular2-token/lib/a2t-ui/a2t-shared/a2t-form/index.js
// module id = ../../../../angular2-token/lib/a2t-ui/a2t-shared/a2t-form/index.js
// module chunks = 3